import React from 'react';
import styled from 'styled-components';
import { 
  Apple, 
  Wifi, 
  Battery, 
  Volume2, 
  Search, 
  User 
} from 'lucide-react';

const MenuBarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 24px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  font-size: 12px;
  color: #333;
  z-index: 1000;
  user-select: none;
`;

const LeftMenu = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

const RightMenu = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

const MenuItem = styled.div`
  cursor: pointer;
  font-weight: 500;
  
  &:hover {
    background: rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 0 4px;
  }
`;

const AppleIcon = styled(Apple)`
  font-size: 14px;
  color: #333;
`;

const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const MenuBar = () => {
  const [currentTime, setCurrentTime] = React.useState('');
  const [currentDate, setCurrentDate] = React.useState('');

  React.useEffect(() => {
    const updateDateTime = () => {
      const now = new Date();
      setCurrentTime(now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
      setCurrentDate(now.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' }));
    };

    updateDateTime();
    const intervalId = setInterval(updateDateTime, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <MenuBarContainer>
      <LeftMenu>
        <MenuItem>
          <AppleIcon size={14} />
        </MenuItem>
        <MenuItem>Aviral Malik's Portfolio</MenuItem>
        <MenuItem>Contact</MenuItem>
        <MenuItem>Resume</MenuItem>
      </LeftMenu>
      
      <RightMenu>
        <StatusIcon>
          <Wifi size={10} />
        </StatusIcon>
        <StatusIcon>
          <Battery size={10} />
        </StatusIcon>
        <StatusIcon>
          <Search size={10} />
        </StatusIcon>
        <StatusIcon>
          <User size={10} />
        </StatusIcon>
        <StatusIcon>
          {currentDate} {currentTime}
        </StatusIcon>
      </RightMenu>
    </MenuBarContainer>
  );
};

export default MenuBar;
